module.exports = __webpack_public_path__ + "media/flags/dm-726ddd1d.svg";